import * as React from 'react';

import styles from './tooltips.module.css';

type TooltipLabelWithLegendProps = {
    name: string;
    iconStyle?: 'dot' | 'square';
    color?: string;
};
export function TooltipLabelWithLegend(props: TooltipLabelWithLegendProps) {
    return (
        <td className={styles['label-container']}>
            {props.iconStyle && props.color ? (
                <div
                    className={
                        props.iconStyle === 'dot' ? styles['legend-dot'] : styles['legend-square']
                    }
                    style={{backgroundColor: props.color}}
                />
            ) : undefined}
            <span>{props.name}</span>
        </td>
    );
}
